// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSurchargeBank_root__8nK2x","text":"PlasmicSurchargeBank_text__lwwyA"};